"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const dialog_handler_template_1 = require("./dialog-handler.template");
class DialogHandler extends events_1.EventEmitter {
    static create(translate) {
        return new DialogHandler(translate, dialog_handler_template_1.template);
    }
    constructor(translate, template) {
        super();
        this._translate = translate;
        this.$dialog = document.createElement('e-dialog');
        this.$dialog.className = 'mce-dialog';
        this.$dialog.headline = translate('dialogHeadline');
        this.$dialog.innerHTML = template(this._translate);
        this._initButtons();
    }
    openDialog() {
        const headerContainer = document.createElement('div');
        const contentContainer = document.createElement('div');
        this.$dialog.open();
        this.$dialog.setHeader(headerContainer);
        this.$dialog.setContent(contentContainer);
        return { headerContainer, contentContainer };
    }
    _initButtons() {
        const $okButton = this.$dialog.querySelector('.e-dialog__footer .e-btn.e-btn-primary');
        const $cancelButton = this.$dialog.querySelector('.e-dialog__footer .e-btn.cancel-btn');
        $okButton.addEventListener('click', () => {
            this.emit('apply');
            this.$dialog.close();
        });
        $cancelButton.addEventListener('click', () => {
            this.emit('cancel');
            this.$dialog.close();
        });
    }
}
exports.DialogHandler = DialogHandler;
//# sourceMappingURL=dialog-handler.js.map